import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageHorses,
  PageHorse,
} from '../pages/horses';

const RouteHorses = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageHorses />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageHorse />
      </Route>
    </Switch>
  );
};

export default RouteHorses;
